<template>
  <template v-if="errorMessageDetails">
    <gsp-alert-error
      v-for="(messageContext, index) in errorMessageDetails.messageContexts"
      :key="index"
      :class="{
        'vm-mt-4': index != 0,
      }"
      role="alert"
    >
      <VTRuntimeTemplate
        :templateT="errorMessageDetails.messageConfig.labelKey"
        :template-props="messageContext"
      />
    </gsp-alert-error>
  </template>
  <slot v-else name="no-error-found" />
</template>

<script setup>
import { computed } from "vue";
import { accountNumberMask } from "~/lib/myMaska";
import { isValidErrorsArray } from "~/utils/service-error-handling";
import { replaceBreaks } from "~/utils/miscellaneous";

const props = defineProps({
  errorData: {
    type: Object,
  },
  bankData: {
    type: Object,
  },
});

const defaultErrorMessageConfig = {
  labelKey: "htmlMarkup.addBankOtherFailMessage",
  requireServiceError: true,
};

const errorMessageConfig = {
  ADV_BANK_SOFT_FAIL: "htmlMarkup.addBankSoftFailMessage",
  ADV_BANK_HARD_FAIL: "htmlMarkup.addBankHardFailMessage",
  ADV_BANK_DECLINED: {
    labelKey: "htmlMarkup.addBankDeniedFailMessage",
    requireServiceError: true,
  },
  ADV_BANK_PASS: defaultErrorMessageConfig,
};

const errorMessageDetails = computed(() => {

  let { bankVerificationResult, errors } = props.errorData || {};

  if (
    (!bankVerificationResult && !isValidErrorsArray(errors))
  )
    return;

  let messageConfig =
    errorMessageConfig[bankVerificationResult] ||
    defaultErrorMessageConfig;

  messageConfig =
    typeof messageConfig == "string"
      ? {
          labelKey: messageConfig,
        }
      : messageConfig;

  const commonMessageContext = {
    maskedAccountNumber: accountNumberMask(props.bankData.bankAccountNumber),
  };

  errors = errors || [null];

  const getMessageContext = (errorIndex) => {
    const error = errors[errorIndex];

    return {
      ...commonMessageContext,
      serviceErrorMessage: replaceBreaks(error?.errorMessage),
      serviceErrorCode: error?.errorCode,
      serviceErrorIndex: errorIndex,
      serviceErrors: errors,
    };
  };

  return {
    messageConfig,
    messageContexts: messageConfig.requireServiceError
      ? errors.map((error, index) => getMessageContext(index))
      : [getMessageContext()],
  };
});
</script>
